import { settingsConstants } from '../_constants';

export function settingsReducer(state = {}, action) {
  switch (action.type) {
    case settingsConstants.SETTINGS_REQUEST:
      return {
        requesting: true
      }
    case settingsConstants.SETTINGS_SUCCESS:
      return {
        success: true
      }
    case settingsConstants.SETTINGS_FAILURE:
      return {
        success: false
      }
    default:
      return {
        state: {}
      }
  }
}